import { useState, useEffect } from 'react';
import { useUserSettingsQuery } from './useQueries.ts';

interface PurchaseFormState {
  amount: number;
  setAmount: (value: number) => void;
  expiryDate: string;
  setExpiryDate: (value: string) => void;
  locationId: number | null;
  setLocationId: (id: number | null) => void;
  computeExpiryFromDefaultDays: (days: number) => string;
}

export function usePurchaseForm(initial?: Partial<PurchaseFormState>): PurchaseFormState {
  const [amount, setAmount] = useState(initial?.amount ?? 1);
  const [expiryDate, setExpiryDate] = useState(initial?.expiryDate ?? '');
  const [locationId, setLocationId] = useState(initial?.locationId ?? null);
  const { data: userSettings } = useUserSettingsQuery();

  useEffect(() => {
    if (userSettings && locationId === null) {
      const presetLocationId = userSettings.product_presets_location_id;
      if (presetLocationId && !isNaN(Number(presetLocationId))) {
        setLocationId(Number(presetLocationId));
      }
    }
  }, [userSettings, locationId]);

  const computeExpiryFromDefaultDays = (days: number): string => {
    if (days === 0) return '';
    if (days < 0) return '2999-12-31';
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString().split('T')[0];
  };

  return { amount, setAmount, expiryDate, setExpiryDate, locationId, setLocationId, computeExpiryFromDefaultDays };
}
